import { API_URL } from "../../../../../constants";
import * as httpNetworking from "../../../../../httpNetworking";

const LIST_AVAILABLE_CORE_VERSIONS_URL = API_URL + "/saas/multi-tenancy/deployment/teleport/list";
const GET_LIST_AVAILABLE_CORE_VERSIONS_API_VERSION = 0;

type TAvailableCoreVersions = {
    coreVersions: string[];
};

export async function getListAvailableCoreVersions(params: { deploymentType: "production" | "development" }) {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 10000,
        params
    };

    const result = await httpNetworking.simpleGETRequest(
        LIST_AVAILABLE_CORE_VERSIONS_URL,
        options,
        GET_LIST_AVAILABLE_CORE_VERSIONS_API_VERSION
    );
    return result.data as TAvailableCoreVersions;
}
